import { Injectable } from '@angular/core'
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { LoginService } from '../login/login.service'

@Injectable({
  providedIn: 'root'
})
export class Authguard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  canActivate = (route: any, state: RouterStateSnapshot) => {
    // ✅ If user is already logged in (via service)
    if (this.loginService.isLoggedIn()) {
      return true;
    }

    // ✅ Try fallback — check localStorage for token
    let token = localStorage.getItem('token');
    if (token && token.split('.').length === 3) {
      console.log('✅ Token found in localStorage');
      return true;
    }

    // ✅ Try to extract token from URL (?token=...)
    const url = state.url;
    const tokenMatch = url.match(/[?&]token=([^&]+)/);

    if (tokenMatch && tokenMatch[1]) {
      token = decodeURIComponent(tokenMatch[1]);

      // Validate JWT format (3 parts)
      if (token.split('.').length === 3) {
        localStorage.setItem('token', token);
        console.log('✅ Token stored from URL:', token);
        return true;
      } else {
        console.error('❌ Invalid JWT format:', token);
      }
    }

    // 🚫 If all checks fail, redirect to login
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
